import type { Icon as PhosphorGlyph, IconProps } from '@phosphor-icons/react/dist/lib/types'

import { AppWindowIcon as AppWindowGlyph } from '@phosphor-icons/react/dist/csr/AppWindow'
import { ArrowElbowDownLeftIcon as ArrowElbowDownLeftGlyph } from '@phosphor-icons/react/dist/csr/ArrowElbowDownLeft'
import { ArrowLeftIcon as ArrowLeftGlyph } from '@phosphor-icons/react/dist/csr/ArrowLeft'
import { ArrowRightIcon as ArrowRightGlyph } from '@phosphor-icons/react/dist/csr/ArrowRight'
import { ArrowSquareOutIcon as ArrowSquareOutGlyph } from '@phosphor-icons/react/dist/csr/ArrowSquareOut'
import { ArrowsOutIcon as ArrowsOutGlyph } from '@phosphor-icons/react/dist/csr/ArrowsOut'
import { BookOpenTextIcon as BookOpenTextGlyph } from '@phosphor-icons/react/dist/csr/BookOpenText'
import { BooksIcon as BooksGlyph } from '@phosphor-icons/react/dist/csr/Books'
import { BrowsersIcon as BrowsersGlyph } from '@phosphor-icons/react/dist/csr/Browsers'
import { BuildingsIcon as BuildingsGlyph } from '@phosphor-icons/react/dist/csr/Buildings'
import { CakeIcon as CakeGlyph } from '@phosphor-icons/react/dist/csr/Cake'
import { CalendarIcon as CalendarGlyph } from '@phosphor-icons/react/dist/csr/Calendar'
import { CalendarDotsIcon as CalendarDotsGlyph } from '@phosphor-icons/react/dist/csr/CalendarDots'
import { CaretDownIcon as CaretDownGlyph } from '@phosphor-icons/react/dist/csr/CaretDown'
import { CaretLeftIcon as CaretLeftGlyph } from '@phosphor-icons/react/dist/csr/CaretLeft'
import { CaretRightIcon as CaretRightGlyph } from '@phosphor-icons/react/dist/csr/CaretRight'
import { ChartLineUpIcon as ChartLineUpGlyph } from '@phosphor-icons/react/dist/csr/ChartLineUp'
import { ChatCircleIcon as ChatCircleGlyph } from '@phosphor-icons/react/dist/csr/ChatCircle'
import { CheckIcon as CheckGlyph } from '@phosphor-icons/react/dist/csr/Check'
import { CheckCircleIcon as CheckCircleGlyph } from '@phosphor-icons/react/dist/csr/CheckCircle'
import { CopyIcon as CopyGlyph } from '@phosphor-icons/react/dist/csr/Copy'
import { CrownIcon as CrownGlyph } from '@phosphor-icons/react/dist/csr/Crown'
import { CubeIcon as CubeGlyph } from '@phosphor-icons/react/dist/csr/Cube'
import { DeviceMobileIcon as DeviceMobileGlyph } from '@phosphor-icons/react/dist/csr/DeviceMobile'
import { DeviceTabletIcon as DeviceTabletGlyph } from '@phosphor-icons/react/dist/csr/DeviceTablet'
import { DotsThreeIcon as DotsThreeGlyph } from '@phosphor-icons/react/dist/csr/DotsThree'
import { DownloadSimpleIcon as DownloadSimpleGlyph } from '@phosphor-icons/react/dist/csr/DownloadSimple'
import { EnvelopeSimpleIcon as EnvelopeSimpleGlyph } from '@phosphor-icons/react/dist/csr/EnvelopeSimple'
import { EyeIcon as EyeGlyph } from '@phosphor-icons/react/dist/csr/Eye'
import { EyeSlashIcon as EyeSlashGlyph } from '@phosphor-icons/react/dist/csr/EyeSlash'
import { FacebookLogoIcon as FacebookLogoGlyph } from '@phosphor-icons/react/dist/csr/FacebookLogo'
import { FileIcon as FileGlyph } from '@phosphor-icons/react/dist/csr/File'
import { FileArrowUpIcon as FileArrowUpGlyph } from '@phosphor-icons/react/dist/csr/FileArrowUp'
import { FileTextIcon as FileTextGlyph } from '@phosphor-icons/react/dist/csr/FileText'
import { FlowArrowIcon as FlowArrowGlyph } from '@phosphor-icons/react/dist/csr/FlowArrow'
import { FunnelIcon as FunnelGlyph } from '@phosphor-icons/react/dist/csr/Funnel'
import { FunnelSimpleIcon as FunnelSimpleGlyph } from '@phosphor-icons/react/dist/csr/FunnelSimple'
import { GearSixIcon as GearSixGlyph } from '@phosphor-icons/react/dist/csr/GearSix'
import { GlobeIcon as GlobeGlyph } from '@phosphor-icons/react/dist/csr/Globe'
import { GrainsIcon as GrainsGlyph } from '@phosphor-icons/react/dist/csr/Grains'
import { HammerIcon as HammerGlyph } from '@phosphor-icons/react/dist/csr/Hammer'
import { HandHeartIcon as HandHeartGlyph } from '@phosphor-icons/react/dist/csr/HandHeart'
import { HeartIcon as HeartGlyph } from '@phosphor-icons/react/dist/csr/Heart'
import { HouseIcon as HouseGlyph } from '@phosphor-icons/react/dist/csr/House'
import { InfoIcon as InfoGlyph } from '@phosphor-icons/react/dist/csr/Info'
import { InstagramLogoIcon as InstagramLogoGlyph } from '@phosphor-icons/react/dist/csr/InstagramLogo'
import { LayoutIcon as LayoutGlyph } from '@phosphor-icons/react/dist/csr/Layout'
import { LeafIcon as LeafGlyph } from '@phosphor-icons/react/dist/csr/Leaf'
import { LinkSimpleIcon as LinkSimpleGlyph } from '@phosphor-icons/react/dist/csr/LinkSimple'
import { ListIcon as ListGlyph } from '@phosphor-icons/react/dist/csr/List'
import { LockIcon as LockGlyph } from '@phosphor-icons/react/dist/csr/Lock'
import { MagnifyingGlassIcon as MagnifyingGlassGlyph } from '@phosphor-icons/react/dist/csr/MagnifyingGlass'
import { MegaphoneIcon as MegaphoneGlyph } from '@phosphor-icons/react/dist/csr/Megaphone'
import { MessengerLogoIcon as MessengerLogoGlyph } from '@phosphor-icons/react/dist/csr/MessengerLogo'
import { MoneyIcon as MoneyGlyph } from '@phosphor-icons/react/dist/csr/Money'
import { MonitorIcon as MonitorGlyph } from '@phosphor-icons/react/dist/csr/Monitor'
import { MoonIcon as MoonGlyph } from '@phosphor-icons/react/dist/csr/Moon'
import { NewspaperIcon as NewspaperGlyph } from '@phosphor-icons/react/dist/csr/Newspaper'
import { PaletteIcon as PaletteGlyph } from '@phosphor-icons/react/dist/csr/Palette'
import { PaperPlaneRightIcon as PaperPlaneRightGlyph } from '@phosphor-icons/react/dist/csr/PaperPlaneRight'
import { PaperPlaneTiltIcon as PaperPlaneTiltGlyph } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt'
import { PawPrintIcon as PawPrintGlyph } from '@phosphor-icons/react/dist/csr/PawPrint'
import { PencilSimpleIcon as PencilSimpleGlyph } from '@phosphor-icons/react/dist/csr/PencilSimple'
import { PencilSimpleLineIcon as PencilSimpleLineGlyph } from '@phosphor-icons/react/dist/csr/PencilSimpleLine'
import { PersonSimpleRunIcon as PersonSimpleRunGlyph } from '@phosphor-icons/react/dist/csr/PersonSimpleRun'
import { PlugsConnectedIcon as PlugsConnectedGlyph } from '@phosphor-icons/react/dist/csr/PlugsConnected'
import { PlusIcon as PlusGlyph } from '@phosphor-icons/react/dist/csr/Plus'
import { RocketIcon as RocketGlyph } from '@phosphor-icons/react/dist/csr/Rocket'
import { ShapesIcon as ShapesGlyph } from '@phosphor-icons/react/dist/csr/Shapes'
import { SidebarSimpleIcon as SidebarSimpleGlyph } from '@phosphor-icons/react/dist/csr/SidebarSimple'
import { SortDescendingIcon as SortDescendingGlyph } from '@phosphor-icons/react/dist/csr/SortDescending'
import { SparkleIcon as SparkleGlyph } from '@phosphor-icons/react/dist/csr/Sparkle'
import { SquaresFourIcon as SquaresFourGlyph } from '@phosphor-icons/react/dist/csr/SquaresFour'
import { SunIcon as SunGlyph } from '@phosphor-icons/react/dist/csr/Sun'
import { TagIcon as TagGlyph } from '@phosphor-icons/react/dist/csr/Tag'
import { TextboxIcon as TextboxGlyph } from '@phosphor-icons/react/dist/csr/Textbox'
import { ThumbsDownIcon as ThumbsDownGlyph } from '@phosphor-icons/react/dist/csr/ThumbsDown'
import { ThumbsUpIcon as ThumbsUpGlyph } from '@phosphor-icons/react/dist/csr/ThumbsUp'
import { TrashIcon as TrashGlyph } from '@phosphor-icons/react/dist/csr/Trash'
import { TreeStructureIcon as TreeStructureGlyph } from '@phosphor-icons/react/dist/csr/TreeStructure'
import { UserIcon as UserGlyph } from '@phosphor-icons/react/dist/csr/User'
import { UserMinusIcon as UserMinusGlyph } from '@phosphor-icons/react/dist/csr/UserMinus'
import { UsersIcon as UsersGlyph } from '@phosphor-icons/react/dist/csr/Users'
import { WarningIcon as WarningGlyph } from '@phosphor-icons/react/dist/csr/Warning'
import { XIcon as XGlyph } from '@phosphor-icons/react/dist/csr/X'

/*
 * The GoodUnited icon set, the one place screens import icons from.
 *
 * A hybrid of two sources:
 * - Phosphor (https://phosphoricons.com), regular weight, for everyday interface icons. At 24px its
 *   regular weight draws the same 1.5px stroke as the Figma icons. Each one keeps its Phosphor name
 *   with the Icon suffix (CaretDownIcon, MagnifyingGlassIcon), so a name found on phosphoricons.com
 *   is the name used here.
 * - GoodUnited's own icons from Figma (goodunited-icons.tsx): the navigation icons (Insights, Actions,
 *   Acquire, Build, Grow, Supporters, Settings) and the product icons (statuses, Messenger, supporter,
 *   high intent, More, Post, Clock, the GoodUnited mark). Where a meaning has a Figma icon, it wins
 *   over Phosphor everywhere.
 *
 * Icons default to 24px and are hidden from screen readers unless they get an aria-label, alt or role.
 * Size them with the size classes (size-4 in controls, size-5 in menus and tables, size-6 in the sidebar).
 * To add a Phosphor icon, import it below from '@phosphor-icons/react/dist/csr/<Name>' and export it with
 * glyph(). Acquisition and revenue sources use SourceIcon from source-icons.tsx instead.
 */
export type { IconProps }

const labelled = (props: IconProps) => Boolean(props['aria-label'] || props['aria-labelledby'] || props.alt || props.role)

const glyph = (Glyph: PhosphorGlyph, name: string) => {
    const Icon = ({ size = 24, weight = 'regular', ...props }: IconProps) => (
        <Glyph size={size} weight={weight} aria-hidden={labelled(props) ? undefined : 'true'} {...props} />
    )

    Icon.displayName = name

    return Icon
}

export const AppWindowIcon = glyph(AppWindowGlyph, 'AppWindowIcon')
export const ArrowElbowDownLeftIcon = glyph(ArrowElbowDownLeftGlyph, 'ArrowElbowDownLeftIcon')
export const ArrowLeftIcon = glyph(ArrowLeftGlyph, 'ArrowLeftIcon')
export const ArrowRightIcon = glyph(ArrowRightGlyph, 'ArrowRightIcon')
export const ArrowSquareOutIcon = glyph(ArrowSquareOutGlyph, 'ArrowSquareOutIcon')
export const ArrowsOutIcon = glyph(ArrowsOutGlyph, 'ArrowsOutIcon')
export const BookOpenTextIcon = glyph(BookOpenTextGlyph, 'BookOpenTextIcon')
export const BooksIcon = glyph(BooksGlyph, 'BooksIcon')
export const BrowsersIcon = glyph(BrowsersGlyph, 'BrowsersIcon')
export const BuildingsIcon = glyph(BuildingsGlyph, 'BuildingsIcon')
export const CakeIcon = glyph(CakeGlyph, 'CakeIcon')
export const CalendarIcon = glyph(CalendarGlyph, 'CalendarIcon')
export const CalendarDotsIcon = glyph(CalendarDotsGlyph, 'CalendarDotsIcon')
export const CaretDownIcon = glyph(CaretDownGlyph, 'CaretDownIcon')
export const CaretLeftIcon = glyph(CaretLeftGlyph, 'CaretLeftIcon')
export const CaretRightIcon = glyph(CaretRightGlyph, 'CaretRightIcon')
export const ChartLineUpIcon = glyph(ChartLineUpGlyph, 'ChartLineUpIcon')
export const ChatCircleIcon = glyph(ChatCircleGlyph, 'ChatCircleIcon')
export const CheckIcon = glyph(CheckGlyph, 'CheckIcon')
export const CheckCircleIcon = glyph(CheckCircleGlyph, 'CheckCircleIcon')
export const CopyIcon = glyph(CopyGlyph, 'CopyIcon')
export const CrownIcon = glyph(CrownGlyph, 'CrownIcon')
export const CubeIcon = glyph(CubeGlyph, 'CubeIcon')
export const DeviceMobileIcon = glyph(DeviceMobileGlyph, 'DeviceMobileIcon')
export const DeviceTabletIcon = glyph(DeviceTabletGlyph, 'DeviceTabletIcon')
export const DotsThreeIcon = glyph(DotsThreeGlyph, 'DotsThreeIcon')
export const DownloadSimpleIcon = glyph(DownloadSimpleGlyph, 'DownloadSimpleIcon')
export const EnvelopeSimpleIcon = glyph(EnvelopeSimpleGlyph, 'EnvelopeSimpleIcon')
export const EyeIcon = glyph(EyeGlyph, 'EyeIcon')
export const EyeSlashIcon = glyph(EyeSlashGlyph, 'EyeSlashIcon')
export const FacebookLogoIcon = glyph(FacebookLogoGlyph, 'FacebookLogoIcon')
export const FileIcon = glyph(FileGlyph, 'FileIcon')
export const FileArrowUpIcon = glyph(FileArrowUpGlyph, 'FileArrowUpIcon')
export const FileTextIcon = glyph(FileTextGlyph, 'FileTextIcon')
export const FlowArrowIcon = glyph(FlowArrowGlyph, 'FlowArrowIcon')
export const FunnelIcon = glyph(FunnelGlyph, 'FunnelIcon')
export const FunnelSimpleIcon = glyph(FunnelSimpleGlyph, 'FunnelSimpleIcon')
export const GearSixIcon = glyph(GearSixGlyph, 'GearSixIcon')
export const GlobeIcon = glyph(GlobeGlyph, 'GlobeIcon')
export const GrainsIcon = glyph(GrainsGlyph, 'GrainsIcon')
export const HammerIcon = glyph(HammerGlyph, 'HammerIcon')
export const HandHeartIcon = glyph(HandHeartGlyph, 'HandHeartIcon')
export const HeartIcon = glyph(HeartGlyph, 'HeartIcon')
export const HouseIcon = glyph(HouseGlyph, 'HouseIcon')
export const InfoIcon = glyph(InfoGlyph, 'InfoIcon')
export const InstagramLogoIcon = glyph(InstagramLogoGlyph, 'InstagramLogoIcon')
export const LayoutIcon = glyph(LayoutGlyph, 'LayoutIcon')
export const LeafIcon = glyph(LeafGlyph, 'LeafIcon')
export const LinkSimpleIcon = glyph(LinkSimpleGlyph, 'LinkSimpleIcon')
export const ListIcon = glyph(ListGlyph, 'ListIcon')
export const LockIcon = glyph(LockGlyph, 'LockIcon')
export const MagnifyingGlassIcon = glyph(MagnifyingGlassGlyph, 'MagnifyingGlassIcon')
export const MegaphoneIcon = glyph(MegaphoneGlyph, 'MegaphoneIcon')
export const MessengerLogoIcon = glyph(MessengerLogoGlyph, 'MessengerLogoIcon')
export const MoneyIcon = glyph(MoneyGlyph, 'MoneyIcon')
export const MonitorIcon = glyph(MonitorGlyph, 'MonitorIcon')
export const MoonIcon = glyph(MoonGlyph, 'MoonIcon')
export const NewspaperIcon = glyph(NewspaperGlyph, 'NewspaperIcon')
export const PaletteIcon = glyph(PaletteGlyph, 'PaletteIcon')
export const PaperPlaneRightIcon = glyph(PaperPlaneRightGlyph, 'PaperPlaneRightIcon')
export const PaperPlaneTiltIcon = glyph(PaperPlaneTiltGlyph, 'PaperPlaneTiltIcon')
export const PawPrintIcon = glyph(PawPrintGlyph, 'PawPrintIcon')
export const PencilSimpleIcon = glyph(PencilSimpleGlyph, 'PencilSimpleIcon')
export const PencilSimpleLineIcon = glyph(PencilSimpleLineGlyph, 'PencilSimpleLineIcon')
export const PersonSimpleRunIcon = glyph(PersonSimpleRunGlyph, 'PersonSimpleRunIcon')
export const PlugsConnectedIcon = glyph(PlugsConnectedGlyph, 'PlugsConnectedIcon')
export const PlusIcon = glyph(PlusGlyph, 'PlusIcon')
export const RocketIcon = glyph(RocketGlyph, 'RocketIcon')
export const ShapesIcon = glyph(ShapesGlyph, 'ShapesIcon')
export const SidebarSimpleIcon = glyph(SidebarSimpleGlyph, 'SidebarSimpleIcon')
export const SortDescendingIcon = glyph(SortDescendingGlyph, 'SortDescendingIcon')
export const SparkleIcon = glyph(SparkleGlyph, 'SparkleIcon')
export const SquaresFourIcon = glyph(SquaresFourGlyph, 'SquaresFourIcon')
export const SunIcon = glyph(SunGlyph, 'SunIcon')
export const TagIcon = glyph(TagGlyph, 'TagIcon')
export const TextboxIcon = glyph(TextboxGlyph, 'TextboxIcon')
export const ThumbsDownIcon = glyph(ThumbsDownGlyph, 'ThumbsDownIcon')
export const ThumbsUpIcon = glyph(ThumbsUpGlyph, 'ThumbsUpIcon')
export const TrashIcon = glyph(TrashGlyph, 'TrashIcon')
export const TreeStructureIcon = glyph(TreeStructureGlyph, 'TreeStructureIcon')
export const UserIcon = glyph(UserGlyph, 'UserIcon')
export const UserMinusIcon = glyph(UserMinusGlyph, 'UserMinusIcon')
export const UsersIcon = glyph(UsersGlyph, 'UsersIcon')
export const WarningIcon = glyph(WarningGlyph, 'WarningIcon')
export const XIcon = glyph(XGlyph, 'XIcon')

export * from '@/components/icons/goodunited-icons'
